<template>
    <div>
        <DropdownItem
            :divided="isDivided"
            :selected="selectedStatus === BannerQaStatus.Draft"
            data-testid="production-status--draft"
            @click="emitStatus(BannerQaStatus.Draft)"
        >
            <QaStatusDot :status="BannerQaStatus.Draft" />
            {{ BannerQaStatusLabel[BannerQaStatus.Draft] }}
        </DropdownItem>
        <DropdownItem
            :selected="selectedStatus === BannerQaStatus.InReview"
            data-testid="production-status--in-review"
            @click="emitStatus(BannerQaStatus.InReview)"
        >
            <QaStatusDot :status="BannerQaStatus.InReview" />
            {{ BannerQaStatusLabel[BannerQaStatus.InReview] }}
        </DropdownItem>
        <DropdownItem
            :selected="selectedStatus === BannerQaStatus.Approved"
            data-testid="production-status--approved"
            @click="emitStatus(BannerQaStatus.Approved)"
        >
            <QaStatusDot :status="BannerQaStatus.Approved" />
            {{ BannerQaStatusLabel[BannerQaStatus.Approved] }}
        </DropdownItem>
        <DropdownItem
            :selected="selectedStatus === BannerQaStatus.Rejected"
            data-testid="production-status--rejected"
            @click="emitStatus(BannerQaStatus.Rejected)"
        >
            <QaStatusDot :status="BannerQaStatus.Rejected" />
            {{ BannerQaStatusLabel[BannerQaStatus.Rejected] }}
        </DropdownItem>
    </div>
</template>

<script lang="ts">
import QaStatusDot from "@/components/Qa/QaStatusDot.vue";
import { BannerQaStatus, BannerQaStatusLabel } from "@/enums/banners";
import type { PropType } from "vue";

export default {
    components: {
        QaStatusDot
    },
    props: {
        isDivided: {
            type: Boolean
        },
        selectedStatus: {
            type: String as PropType<(typeof BannerQaStatus)[keyof typeof BannerQaStatus]>
        }
    },

    emits: ["statusSelected"],

    data() {
        return {
            BannerQaStatus,
            BannerQaStatusLabel
        };
    },

    methods: {
        emitStatus(status: (typeof BannerQaStatus)[keyof typeof BannerQaStatus]) {
            this.$emit("statusSelected", status);
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
